<template>
  <div>
    <router-link :to="{ name: 'callouts' }">
      <BaseIcon name="arrow-left" :class="$style.back" />
    </router-link>
    <CalloutAvatar
      :source="profile && profile.logo"
      :size="40"
      @click.native="showProfile"
      :class="$style.avatar"
    />
    <div v-if="profile" @click="showProfile" :class="$style.title">{{ profile.name }}</div>
    <div v-if="callout" :class="$style.actions">
      <v-popover placement="bottom-end" popoverClass="no-arrow">
        <div :class="$style.actionsButton">
          <BaseIcon custom name="ellipsisX" :class="['tooltip-target']" />
        </div>
        <CalloutMenu :callout="callout" slot="popover" v-close-popover />
      </v-popover>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CalloutMenu from './CalloutMenu'
import CalloutAvatar from './CalloutAvatar'

export default {
  name: 'callout-post-header',
  components: {
    CalloutMenu,
    CalloutAvatar
  },
  props: {
    id: [String, Number]
  },
  computed: {
    ...mapGetters({
      getCallout: 'entities/callouts/find',
      getCalloutProfile: 'entities/calloutProfiles/find'
    }),
    callout () {
      return this.getCallout(Number(this.id))
    },
    profile () {
      if (!this.callout) return
      return this.getCalloutProfile(this.callout.payload.profile)
    }
  },
  methods: {
    showProfile () {
      this.$modal.show('callout-profile', {
        uuid: this.profile.uuid
      })
    }
  }
}
</script>

<style module lang="scss">
.back {
  cursor: pointer;
  font-size: 18px;
  margin-right: 16px;
  color: $text-mid;
  &:hover {
    color: $text-success;
  }
}
.avatar,
.title {
  cursor: pointer;
}
.title {
  font-size: 16px;
  margin-left: 10px;
  flex-grow: 1;
}
.actions {
  display: flex;
  font-size: 20px;
  &Button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 48px;
    margin-left: 10px;
    color: $text-mid-dark;
    &:hover {
      color: $text-colored;
    }
  }
}
</style>
